export const EARNINGS_TAB = 'EARNINGS_TAB';
export const DEGREE_PLANS_TAB = 'DEGREE_PLANS_TAB';
